module.exports = __webpack_public_path__ + "img/pyxpay_usa_logo.c3a85bd3.png";